var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('banner'),_vm._v(" "),_c('chart-view-selection',{on:{"chart-selection":_vm.setSelection}}),_vm._v(" "),(_vm.chartView=='heat-map')?_c('div',[_c('country-chart-view')],1):(_vm.chartView=='data')?_c('div',[_c('directory-search-bar'),_vm._v(" "),_c('bar-chart-view')],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97d1fb7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingPage.vue
// module id = null
// module chunks = 